import React, { lazy } from 'react';
import { RouteConfig } from 'react-router-config';
import IconBugly from '@/assets/images/menu/icon-bugly.react.svg?react';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';

export const electronCrashRoutes = (): RouteConfig[] => [
  {
    path: '/exception/electron-crash',
    name: '崩溃',
    icon: <MenuIcon icon={IconBugly} fontSize={16} />,
    platforms: [
      CapitalPlatform.Electron,
    ],
    routes: [
      {
        path: '/exception/electron-crash/dashboard',
        name: '概览',
        component: lazy(() => import('@/presentation/pages/electron/crash/dashboard')),
      },
      {
        path: '/exception/electron-crash/issues/list',
        name: '问题列表',
        component: lazy(() => import('@/presentation/pages/electron/crash/issues/list')),
      },
      {
        path: '/exception/electron-crash/issues/detail',
        name: '问题详情',
        component: lazy(() => import('@/presentation/pages/electron/crash/issues/detail')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/exception/electron-crash/caller/detail',
        name: '调用方详情',
        component: lazy(() => import('@/presentation/pages/electron/crash/caller-detail')),
        hideInMenu: true,
        whitelisted: true,
      },
    ],
  },
];

export default electronCrashRoutes;
